// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3mUHX","signatureBlock":"Footer_signatureBlock__2yVlv","signature":"Footer_signature__2ivwr"};